module.exports = __webpack_public_path__ + "img/home-jixiao.987e6cfa.png";